module.exports = __webpack_public_path__ + "static/media/btn_cta_right_arrow.a816c8ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/btn_cta_right_arrow.svg
// module id = 117
// module chunks = 0